<template>
  <div class="row p-0">
    <div class="col-md-8 pr-2">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-xl-12">
              <label style="margin-right: 15px">{{ $t("emploi.seance") }}</label>
              <a-select
                v-model="selectedSession"
                @change="onSessionChange"
                :placeholder="$t('emploi.seanceListe')"
                allowClear
                style="width: 190px"
              >
                <a-select-option key="" value="">{{ $t("emploi.seanceListe") }}</a-select-option>
                <a-select-option v-for="name in sessionNamesList" :key="name" :value="name">
                  {{ name }}
                </a-select-option>
              </a-select>
              <a-button
                type="primary"
                style="margin-right: 5px; position: absolute; right: 0"
                :loading="printLoading"
                :disabled="printLoading"
                @click="generatePdf"
              >
                <a-icon v-if="!printLoading" type="file-pdf" />{{ $t("action.imprimer") }}
              </a-button>
            </div>
          </div>
          <a-divider></a-divider>
          <div class="row mb-2">
            <div class="m-auto" style="width: 95%">
              <a-range-picker
                v-model="dateRange"
                format="DD/MM/YYYY"
                style="width: 98%"
                @change="(val) => handleDateRange(val)"
              />
            </div>
          </div>
          <a-divider></a-divider>
          <a-table
            :columns="columns"
            :data-source="tableData"
            row-key="_id"
            :pagination="true"
            :loading="tableLoading"
          >
            <template slot="sessionName" slot-scope="text, record">
              {{ getSessionName(record) }}
            </template>
            <template slot="date" slot-scope="text">
              <a-tag>{{ moment(text).format("DD/MM/YYYY HH:mm") }}</a-tag>
            </template>
            <template slot="type" slot-scope="text">
              <a-tag :color="{ Retard: 'orange', Absence: 'red', Exclus: 'purple' }[text]">
                {{ getTranslatedType(text) }}
              </a-tag>
            </template>
          </a-table>
        </div>
      </div>
    </div>
    <div class="col-md-4 pl-2">
      <div class="card">
        <div class="card-body">
          <div style="text-align: center; margin-top: 15px">
            <h4>{{ $t("assiduite.assiduite") }}</h4>
          </div>
          <a-divider>
            <span class="font-size-18">{{ studentName }}</span>
          </a-divider>
          <attendanceChart
            :subject="selectedSubject"
            style="margin-bottom: 30px"
            :data="data"
            :studentName="studentName"
            :classLevel="classLevel"
          />
          <attendanceBar
            :subject="selectedSubject"
            :data="data"
            :studentName="studentName"
            :classLevel="classLevel"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/*eslint-disable */
import apiClient from "@/services/axios";
import { mapState } from "vuex";
import JsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import attendanceChart from "./components/attendanceChart";
import attendanceBar from "./components/attendanceBar";

export default {
  computed: {
    ...mapState(["settings", "user"]),
    sessionNamesList() {
      const seen = new Set();
      const names = this.data
        .map((d) => (this.getSessionName(d) || "").trim())
        .filter((n) => n && !seen.has(n) && (seen.add(n), true));
      return names.sort();
    },
    tableData() {
      let list = this.selectedSession
        ? this.data.filter((d) => (this.getSessionName(d) || "").trim() === this.selectedSession)
        : this.data;
      if (this.classLevel <= 6) list = list.filter((d) => d.type !== "Exclus");
      return list;
    },
    columns() {
      return [
        { dataIndex: "schedule", key: "session", title: this.$t("emploi.seance"), scopedSlots: { customRender: "sessionName" } },
        {
          dataIndex: "date",
          key: "date",
          title: this.$t("assiduite.date"),
          sorter: (a, b) => moment(a.date).valueOf() - moment(b.date).valueOf(),
          sortDirections: ["descend", "ascend"],
          defaultSortOrder: "descend",
          scopedSlots: { customRender: "date" },
        },
        { dataIndex: "type", key: "type", title: this.$t("recette.type"), scopedSlots: { customRender: "type" } },
      ];
    },
  },
  props: {
    studentId: { required: true },
    classRoomId: { required: true },
    studentName: { required: true },
    classLevel: { required: true },
  },
  components: { attendanceChart, attendanceBar },
  data() {
    return {
      printLoading: false,
      tableLoading: false,
      data: [],
      rowData: [],
      selectedSession: "",
      selectedSubject: "",
      dateRange: null,
    };
  },
  async created() {
    this.$gtag.pageview({
      page_path: this.$route.path,
      page_location: window.location.href,
      page_title: document.title + " - Assiduité",
    });
    const sy = (this.settings.schoolarYears || []).find(
      (el) => el._id === this.settings.activeSchoolarYear
    );
    if (sy && sy.start && sy.end) {
      this.dateRange = [moment(sy.start), moment(sy.end)];
    }
    this.tableLoading = true;
    const { data } = await apiClient.post("/attendance/getAttendance", { student: this.studentId });
    const filtered = (data || []).filter(
      (s) => s.schedule && s.schedule.classeRoom && s.schedule.classeRoom._id === this.classRoomId
    );
    this.data = filtered.map((s) => {
      if (s.schedule && s.schedule.moduleGeneral) s.schedule.subject = s.schedule.moduleGeneral;
      return s;
    });
    this.rowData = [...this.data];
    this.applyDateFilter();
    this.tableLoading = false;
  },
  methods: {
    getSessionName(record) {
      const s = record && record.schedule;
      if (!s) return "";
      if (s.name) return s.name;
      if (s.subject && s.subject.name) return s.subject.name;
      if (s.moduleGeneral && s.moduleGeneral.name) return s.moduleGeneral.name;
      return  "";
    },
    getTranslatedType(type) {
      const map = { Retard: this.$t("assiduite.retard"), Absence: this.$t("assiduite.absence"), Exclus: this.$t("assiduite.exclus") };
      return map[type] || type;
    },
    async generatePdf() {
      this.$gtag.event("Imp eleve assiduite", {
        event_category: "Impression PDF",
        event_label: "ProfileEleve:assiduite",
        value: 1,
      });
      const isArabic = this.$i18n.locale === "ar-AR";
      const reverseIfArabic = (arr) => (isArabic ? arr.slice().reverse() : arr);
      this.printLoading = true;
      let imgData = {};
      (this.settings.image || []).forEach((img) => {
        if (this.settings.activeBuilding === img.db) imgData = { src: img.logo };
      });
      const doc = new JsPDF();
      const pdf_width = doc.internal.pageSize.width;
      doc.setFont("Amiri");
      doc.setFontSize(15);
      doc.setFont("Amiri", "Bold");
      const title = `${this.$t("assiduite.callSheet")} : ${this.studentName}`;
      doc.text((pdf_width - doc.getTextWidth(title)) / 2, 22, title);
      doc.setFont("Amiri", "normal");
      doc.setFontSize(11);
      const startStr = this.dateRange[0] ? moment(this.dateRange[0]).format("DD/MM/YYYY") : "-";
      const endStr = this.dateRange[1] ? moment(this.dateRange[1]).format("DD/MM/YYYY") : "-";
      const dateRangeText = `${this.$t("assiduite.date")}: ${startStr} - ${endStr}`;
      doc.text((pdf_width - doc.getTextWidth(dateRangeText)) / 2, 30, dateRangeText);
      doc.setFontSize(10);
      try {
        if (imgData.src) doc.addImage(imgData.src, "JPEG", isArabic ? pdf_width - 35 : 15, 5, 20, 20);
      } catch (e) {}
      const rows = this.tableData.map((r) =>
        reverseIfArabic([
          this.getSessionName(r),
          moment(r.date).format("DD/MM/YYYY HH:mm"),
          this.getTranslatedType(r.type),
        ])
      );
      doc.autoTable({
        theme: "grid",
        styles: { font: "Amiri", fontSize: 10, cellPadding: 3, halign: isArabic ? "right" : "left" },
        headStyles: { font: "Amiri", fontSize: 10, fontStyle: "bold", halign: isArabic ? "right" : "center" },
        margin: { top: 50 },
        head: [reverseIfArabic([this.$t("assiduite.seance"), this.$t("assiduite.date"), this.$t("assiduite.type")])],
        body: rows,
      });
      this.printLoading = false;
      doc.save(`${this.$t("assiduite.callSheet")} : ${this.studentName}`);
    },
    moment,
    applyDateFilter() {
      if (!this.dateRange || !this.dateRange.length) {
        this.data = [...this.rowData];
        return;
      }
      const start = moment(this.dateRange[0]).startOf("day");
      const end = moment(this.dateRange[1]).endOf("day");
      this.data = this.rowData.filter((s) => {
        if (!s.date) return false;
        const d = moment(s.date).format("YYYY-MM-DD");
        return d >= start.format("YYYY-MM-DD") && d <= end.format("YYYY-MM-DD");
      });
    },
    async handleDateRange(value) {
      if (value && value.length === 2) {
        this.dateRange = value;
        this.selectedSession = "";
        this.applyDateFilter();
      } else {
        const sy = (this.settings.schoolarYears || []).find(
          (el) => el._id === this.settings.activeSchoolarYear
        );
        this.dateRange = sy && sy.start && sy.end ? [moment(sy.start), moment(sy.end)] : null;
        this.selectedSession = "";
        this.applyDateFilter();
      }
    },
    onSessionChange(name) {
      this.selectedSession = name || "";
      this.selectedSubject = this.selectedSession;
    },
  },
};
</script>
<style scoped>
.arabic-font {
  font-size: 14px !important;
  font-family: Verdana, Geneva, Tahoma, sans-serif !important;
}
.success .ant-btn-danger {
  background: #8bc34a !important;
  border-color: #8bc34a !important;
}
</style>
